<nav id="subHeader" class="wab-header scrolling-wrapper">
   <div class="wab-container container-constraint">
      <div>
         <div class="row wab-container-row ">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 flex-list">
               <ul class="nav navbar-nav wab-nav wab-subnav">
                  <li *ngFor="let item of RewardsMenuitems" role="link" class="link">
                     <a class="text-center"
                        [ngClass]="{'selected-link': item.title == title}"
                        [routerLink]="[item.routerLink]">{{item.title}}</a>
                  </li>
               </ul>
            </div>
         </div>
      </div>
   </div>
</nav>